export function isBusinessOwner(user, business) {
    return business.claimStatus === 'claimed' && business.owner === user._id;
}
export function isBusinessClaimer(user, business) {
    return business.claimStatus === 'pending' && business.owner === user._id;
}
export function isBusinessSubmitter(user, business) {
    return business.submissionStatus === 'pending' && business.submittedBy === user._id;
}
export function isBusinessViewable(business) {
    return business.submittedBy === '' || business.submissionStatus === 'approved';
}
